import { gql } from "@apollo/client";

export const renewalQuotation = gql`
  fragment renewalQuotation on Quotation {
    documentId
    offerId
    insurerId
    insurerName
    bonusMalus
    period
    additionalInfo
    runningYN
    sourceOfferId
    currencyCode
    details {
      offerDetailId
      insuranceAmount
      isDirectCompensation
      selected
    }
  }
`;
